import {SufixType} from "../input/common/SufixType";
import {SliderContainer, SliderNotch, SliderNotchContainer, SliderRangeInput, SliderTrack} from "./styled";
import {Flex} from "../flex";
import {BodyText} from "../typography";

export interface SliderBodyProps {
    min: number;
    max: number;
    valueType?: SufixType;
    notches?: number;
    disabled?: boolean;
    required?: boolean;
    currentSliderValue:  number;
    handleSliderChange: (value: string) => void;
}

export const SliderBody: React.FC<SliderBodyProps> = ({
                                                  min,
                                                  max,
                                                  valueType = SufixType.Euro,
                                                  notches = 20,
                                                  disabled,
                                                  required,
                                                  currentSliderValue,
                                                  handleSliderChange
                                              }) => {
    return (
        <>
            <SliderContainer>
                <SliderTrack min={min} max={max} value={currentSliderValue} />
                <SliderNotchContainer>
                    {[...Array(notches)].map((_, i) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <SliderNotch key={i} />
                    ))}
                </SliderNotchContainer>
                <SliderRangeInput
                    type="range"
                    min={min}
                    max={max}
                    step={0.05}
                    value={currentSliderValue}
                    onChange={(event) => handleSliderChange(event.target.value)}
                    disabled={disabled}
                    required={required}
                />
            </SliderContainer>
            <Flex
                alignItems="center"
                justifyContent="space-between"
                flexDirection="row"
                width="100%"
                padding="0 0.2rem">
                <BodyText>{valueType === SufixType.None ? 'Smanji' : `${min} ${valueType}`}</BodyText>
                <BodyText>{valueType === SufixType.None ? 'Povećaj' : `${max} ${valueType}`}</BodyText>
            </Flex>
        </>
    );
}